export default __webpack_public_path__ + "static/media/gallery_04.d8235fc9.jpg";